const colors = {
  primary: "#F7C819",
  primaryDark: "#eec015",
  primary2: "#F5DC7E",
  primary3: "#FBEEBF",
  secondary: "#00918E",
  secondary1: "#30B6B3",
  secondary2: "#9FD3D2",
  primaryText: "#25282B",
  white: "#FFFFFF",
  grey: "#BFBFBF",
  gray3: "#828282",
  gray6: "#F2F2F2",
  blue: "#074EE8",
  borderColor: "#AAAAAA",
  neutral: {
    black1: "#000000",
    black2: "#262626",
    black3: "#595959",
    black4: "#8C8C8C",
    black5: "#BFBFBF",
    black6: "#D9D9D9",
    black7: "#E8E8E8",
    black8: "#F5F5F5",
    black9: "#FAFAFA",
  },
  custom: {
    background: "#EEEDEB",
    darkblue4: "#2F80ED",
    darkblue3: "#273049",
    darkblue2: "#3C4766",
    darkblue1: "#6F7A9A",
  },
  utilities: {
    warning: "#F26C1F",
    error: "#C9273F",
    success: "#7DB30B",
    info: "#1876CC",
  },
  dark: "#767676",
  activeAnchor: "#1890ff",
  radioPrimaryDisabled: "#EFC117",
  radioText: "#111111",
  red: "#EB5757",
};

export default colors;
